<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="home">
    <v-card>
      <v-container class="home-container">
        <v-layout row>
          <v-flex xs2 class="ma-2">
            <v-select
              v-model="selected"
              :items="statuses"
              label="Показать экзамены"
              v-on:change="getExamsList"
            ></v-select>
          </v-flex>
          <v-flex xs2 class="ma-2">
            <v-text-field v-model="searchUserId" label="User id"></v-text-field>
          </v-flex>
          <!-- <v-flex xs5>
            <v-card>
              <h3 class="text-sm-center pt-3 pb-2 body-1 font-weight-regular blue-grey lighten-4">Идентификационные куки</h3>
              <v-expansion-panel
                expand
              >
                <v-expansion-panel-content v-for="location in locations">
                  <template v-slot:header>
                    <span>{{location.address}}</span>
                  </template>
                  <v-card>
                    <v-card-actions v-for="clientId in location.clientsIds">
                      <v-btn small block color="primary" @click.stop="saveEverCookie(location.id, location.address, clientId)">Установить для устройства №{{clientId}}</v-btn>
                      <v-btn small block color="primary" @click.stop="removeEverCookie">Удалить для устройства №{{clientId}}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <h3 class="text-sm-center pt-3 pb-2 body-1 font-weight-regular blue-grey lighten-4">Отключить проверкку локации для пользователя</h3>
              <v-form
                ref="disableCheckingLocation"
                v-model="emailValid"
                class="px-4"
                @submit.prevent="disableCheckingLocation"
              >
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>
                <v-flex class="text-xs-center">
                  <v-btn
                    small
                    color="primary"
                    @click="disableCheckingLocation"
                  >
                    Отключить проверку локации
                  </v-btn>
                </v-flex>
              </v-form>
            </v-card>
          </v-flex> -->
        </v-layout>
        <!-- <v-dialog v-model="dialogLocation" max-width="300">
          <v-card>
            <v-card-text class="text-xs-center">
              {{dialogLocationMessage}}
            </v-card-text>
            <v-card-actions class="align-content-center">
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat="flat" v-on:click="dialogLocation = false">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        <v-data-table
          :headers="headers"
          :items="exams"
          :total-items="totalExams"
          :pagination.sync="pagination"
          :rows-per-page-items="[10, 25, 100]"
          :loading="loading"
          @update:pagination="updatePagination"
        >
          <template slot="items" slot-scope="props">
            <tr v-bind:class="{'exam-success': props.item.passed === 1, 'exam-fail': props.item.passed === 0}">
              <td class="text-xs-center px-0">{{props.item.sessionId}}</td>
              <td class="text-xs-center px-0">
                <a :href=getAccountUrl(props.item.accountId)>{{props.item.accountId}}</a>
                <a v-for="duplicateId in props.item.duplicates" :href=getAccountUrl(duplicateId)><br>{{duplicateId}}</a>
              </td>

              <td class="text-xs-left px-0">
                Старт: {{new Date(props.item.timing.startedAtTs).toLocaleString("en-GB", {timeZone: 'Europe/Kiev'}).slice(0, -3)}} <br>
                Финиш: {{new Date(props.item.timing.finishedAtTs).toLocaleString("en-GB", {timeZone: 'Europe/Kiev'}).slice(0, -3)}}
              </td>

              <td class="text-xs-center px-0 py-2">
                <div v-for="programming in props.item.programming">
                  <ProgrammingCollapse :programming-data="programming" ></ProgrammingCollapse>
                </div>
              </td>

              <td class="text-xs-center px-0">
                <v-icon v-if="props.item.anticheatCodeDetected === false" dark medium color="green">check_circle</v-icon>
                <a v-if="props.item.anticheatCodeDetected === true" :href="props.item.anticheatCodeUrl" target="_blank" style="text-decoration:none">
                  <v-icon medium color="warning">warning</v-icon>
                </a>
              </td>

              <td class="text-xs-center px-0">
                <div class="exam-logs">
                  <v-icon v-if="props.item.hasWarningLog" medium color="warning">warning</v-icon>
                  <a :href="getLogsUrl(props.item.sessionId)" target="_blank">{{props.item.totalLogs}}</a>
                </div>
              </td>

              <td class="text-xs-center px-0">
                <span v-if="props.item.passed === null">Ожидает проверки</span>
                <span v-if="props.item.passed === 0">Провален</span>
                <span v-if="props.item.passed === 1">Успешно пройден</span>
              </td>

              <td class="text-xs-center px-0">
                <div v-if="props.item.passed === null">
                  <v-dialog
                    v-model="dialogAccept[props.item.sessionId]"
                    max-width="300"
                    persistent
                  >
                    <template v-slot:activator="{on}">
                      <v-btn class="action-btn" block top small color="success" v-on="on">Принять</v-btn>
                    </template>
                    <v-card>
                      <v-card-text class="text-xs-center">
                        Вы уверены в своем выборе?
                      </v-card-text>
                      <v-textarea
                        v-model="comment"
                        :rules="commentRules"
                        label="Добавить коммент (необязательно)"
                        rows="1"
                        placeholder=" "
                        class="mx-2 body-2 font-weight-regular"
                      ></v-textarea>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat="flat" v-on:click="closeDialog">Нет</v-btn>
                        <v-btn color="green darken-1" flat="flat" v-on:click="checkExam(props.item.sessionId, true, comment)">Да</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-dialog
                    v-model="dialogDecline[props.item.sessionId]"
                    max-width="300"
                    persistent
                  >
                    <template v-slot:activator="{on}">
                      <v-btn class="action-btn" block small color="error" v-on="on">Отклонить</v-btn>
                    </template>
                    <v-card>
                      <v-card-text class="text-xs-center">
                        Вы уверены в своем выборе?
                      </v-card-text>
                      <v-textarea
                        v-model="comment"
                        :rules="commentRules"
                        label="Добавить коммент (необязательно)"
                        rows="1"
                        placeholder=" "
                        class="mx-2 body-2 font-weight-regular"
                      ></v-textarea>
                      <v-checkbox
                        class="cheater-checkbox"
                        v-model="cheater"
                        label="читер"
                      ></v-checkbox>
                      <v-card-actions class="align-content-center">
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat="flat" v-on:click="closeDialog">Нет</v-btn>
                        <v-btn color="green darken-1" flat="flat" v-on:click="checkExam(props.item.sessionId, false, comment, cheater)">Да</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>

                <div v-if="props.item.passed === 0" class="mx-2">
                  <v-btn class="action-btn white--text blue-grey white--text" block small v-on:click="deleteExam(props.item.sessionId)">Сбросить результат</v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import Vue from "vue";
import ProgrammingCollapse from "@/components/ProgrammingCollapse.vue";
import config from "@/config/locations";
import {urls} from "@/config";

export default Vue.extend({
  name: "home",
  components: {
    ProgrammingCollapse
  },

  data() {
    return {
      dialogAccept: [],
      dialogDecline: [],
      dialogLocation: false,
      dialogLocationMessage: "",

      locations: config.locations,

      statuses: [
        {value: "all", text: "все"},
        {value: "unchecked", text: "ожидают проверки"},
        {value: "passed", text: "успешно пройденные"},
        {value: "failed", text: "проваленные"}
      ],

      headers: [
        {value: "sessionId", text: "#", align: "center"},
        {value: "accountId", text: "Профиль", align: "center", sortable: false},
        {value: "timing", text: "Время", sortable: false, align: "center"},
        {value: "programming", text: "Программирование", sortable: false, align: "center", width: "40%"},
        {value: "anticheat", text: "Античит", align: "center", sortable: false},
        {value: "logs", text: "Логи", align: "center", sortable: false},
        {value: "status", text: "Статус", align: "center", sortable: false, width: "5%"},
        {value: "action", text: "Действие", sortable: false, align: "center", width: "10%"}
      ],

      pagination: {
        descending: true,
        sortBy: "sessionId"
      },

      emailValid: true,
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      comment: "",
      commentRules: [
        (v) => v.length < 1000 || "Comment length must be less than 10 chars"
      ],

      searchUserId: "",
      loading: false,
      cheater: false
    };
  },

  computed: {
    filteredExams() {
      return this.$store.state.exams.list.filter((e) => ("" + e.accountId).includes(this.searchUserId));
    },
    selected() {
      return this.$store.state.exams.selected;
    },

    exams() {
      return this.filteredExams;
    },

    totalExams() {
      return this.$store.state.exams.total;
    }
  },

  methods: {
    async saveEverCookie(locationId, locationAddress, clientId) {
      const token = await this.getRandomString();

      await this.$store.dispatch("client/saveEverCookie", {
          locationId,
          locationAddress,
          clientId,
          token
      });

      this.showDialogLocation("Идентификационная кука сохранена");
    },

    async removeEverCookie() {
      await this.$store.dispatch("client/removeEverCookie");
      this.showDialogLocation("Идентификационная кука удалена");
    },

    async disableCheckingLocation() {
      if (this.emailValid) {
        this.showDialogLocation("Проверка локации для юзера " + this.email + " отключена");
        try {
          await this.$store.dispatch("client/disableCheckingLocation", {
            email: this.email
          });
          this.showDialogLocation("Проверка локации для пользователя " + this.email + " отключена");
        } catch (e) {
          if (e.code === 404) {
            this.showDialogLocation("Пользователь " + this.email + " не найден");
          } else {
            this.showDialogLocation("Упс, что-то пошло не так...");
          }
        }
      }
    },

    async getExamsList(status) {
      this.loading = true;
      await this.$store.dispatch("exams/getExams", {
        key: status,
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        limit: this.pagination.rowsPerPage
      });
      this.loading = false;
    },

    async checkExam(session, passed, comment, cheater) {
      this.closeDialog();

      await this.$store.dispatch("exams/checkExam", {
        status: this.selected,
        result: {
          sessionId: session,
          passed,
          comment,
          cheater
        },
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        limit: this.pagination.rowsPerPage
      });
    },

    async deleteExam(session) {
      await this.$store.dispatch("exams/deleteExam", {
        status: this.selected,
        data: {
          sessionId: session,
        },
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        limit: this.pagination.rowsPerPage
      });
    },

    closeDialog() {
      this.comment = "";
      this.cheater = false;
      this.dialogAccept = [];
      this.dialogDecline = [];
    },

    showDialogLocation(message) {
      this.dialogLocationMessage = message;
      this.dialogLocation = true;
    },

    getRandomString() {
      const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      const length = 20;
      let randomString = "";

      for (let i = 0; i < length; i++) {
        randomString += possible.charAt(Math.floor(Math.random() * possible.length));
      }

      return randomString;
    },

    getAccountUrl(accountId) {
        return urls.userProfile + "/" + accountId;
    },

    async updatePagination() {
        if (!new URLSearchParams(window.location.search).get("userId")) {
          await this.getExamsList(this.selected);
        }
    },

    getLogsUrl(sessionId) {
      return "https://admin.exam.scs.programming.org.ua/logs?sessionId=" + sessionId;
    }
  },

  mounted() {
    const queryParams = new URLSearchParams(window.location.search);
    this.searchUserId = queryParams.get("userId") || "";
    if (this.searchUserId) {
      this.$set(this.pagination, "rowsPerPage", 10);
    }
  }
});
</script>

<style>
  .exam-success {
    background-color: #A9F5BC;
  }

  .exam-fail {
    background-color: #FA8258;
  }

  .home-container {
    max-width: 100%;
  }

  .exam-logs {
    display: flex;
    flex-direction: column;
  }

  .cheater-checkbox {
    margin: 0 5px;
    font-size: 12px;
  }
</style>
